import ApiBase from 'Services/Api/ApiBase';

class UserSettings extends ApiBase {
    route = '/admin/human-resources/:user/user-settings';
};

export default new UserSettings();